module.exports = __webpack_public_path__ + "static/media/nav_guide.f9d92134.png";